export default __webpack_public_path__ + "static/media/xcode.b3107331.svg";